(() => {
  const key="__um760StageState";
  const state=window[key]||(window[key]={observed:new WeakSet(),observer:null});
  if(state.started)return;
  state.started=true;
  const fit=(wrap)=>{
    if(!wrap||!wrap.isConnected)return;
    const stage=wrap.querySelector(".um760__stage"); if(!stage)return;
    const bw=Number(wrap.dataset.stageWidth)||1464;
    const bh=Number(wrap.dataset.stageHeight)||600;
    const w=wrap.clientWidth;if(!w)return;
    const s=w/bw; stage.style.transformOrigin="0 0"; stage.style.transform="scale("+s+")";
    wrap.style.height=(bh*s)+"px";
  };
  const scan=(scope=document)=>{
    const wraps=scope.querySelectorAll?scope.querySelectorAll("[data-um760-module] .um760__stage-wrap"):[];
    wraps.forEach(w=>{fit(w);if(state.observer&&!state.observed.has(w)){state.observer.observe(w);state.observed.add(w);}});
  };
  if(!state.observer&&"ResizeObserver" in window)state.observer=new ResizeObserver(es=>es.forEach(e=>fit(e.target)));
  const boot=()=>scan(document);
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot,{once:true});else requestAnimationFrame(boot);
  if(!state.shopifyBound){state.shopifyBound=true;document.addEventListener("shopify:section:load",e=>scan(e.target||document));}
})();